import {
  NumberComparisonOperator,
  numberComparisonToLabel,
} from "@redotech/redo-model/advanced-flow/expressions/number-expression";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const IntegerComparisonDetails = memo(function IntegerComparisonDetails({
  field,
  matchType,
  matchValue,
  prefix,
  suffix,
}: {
  field: string;
  matchType?: NumberComparisonOperator;
  matchValue?: number;
  prefix?: string;
  suffix?: string;
}) {
  return (
    <>
      {"If "}
      <Text fontWeight="semibold">{field}</Text>
      {" is "}
      <Text>
        {matchType ? `${numberComparisonToLabel[matchType]} ` : undefined}
      </Text>
      <Text fontWeight="semibold">
        {prefix}
        {matchValue ? matchValue.toString() : undefined}
        {suffix}
      </Text>
    </>
  );
});
